import { render, staticRenderFns } from "./FreeEvaluation.vue?vue&type=template&id=649a16d4&scoped=true"
import script from "./FreeEvaluation.vue?vue&type=script&lang=js"
export * from "./FreeEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a16d4",
  null
  
)

export default component.exports